import { ReactNode } from "react";

import Form from "@atlaskit/form";

import { Separator as DefaultSeparator } from "@/components/signup/account-creation/components/separator/separator";

import { AccountSigninContextProvider } from "../hooks/account-signin-context";
import { useAccountSigninContext } from "../hooks/account-signin-context";

import { Error as DefaultError } from "./error";
import { Input as DefaultInput } from "./input";
import { Login as DefaultLogin } from "./login";
import { Social as DefaultSocial } from "./social";
import { Submit as DefaultSubmit } from "./submit";

const AccountSigninContent = ({
    Submit = <DefaultSubmit />,
    Input = <DefaultInput />,
    Social = <DefaultSocial />,
    Separator = <DefaultSeparator />,
    Error = <DefaultError />,
    Login = <DefaultLogin />
}: {
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => {
    const { onSubmitWithReCAPTCHA } = useAccountSigninContext();

    return (
        <>
            <Form onSubmit={onSubmitWithReCAPTCHA} isDisabled={false}>
                {({ formProps }) => (
                    <form
                        {...formProps}
                        autoComplete="off"
                        data-testid="account-signin"
                    >
                        {Input}
                        {Submit}
                    </form>
                )}
            </Form>
            {Error}
            {Separator}
            {Social}
            {Login}
        </>
    );
};

export const AccountSignin = (props: {
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => {
    return (
        <AccountSigninContextProvider>
            <AccountSigninContent {...props} />
        </AccountSigninContextProvider>
    );
};
